export const ICachedImageViewModelType = Symbol('ICachedImageViewModel');
